import React from 'react';
import { EllipsisSpan, MxColumnType } from '@maxtropy/components';
import { FilterModeDisplay } from '@/shared/const';
import { getRange } from '@/shared/utils/utils';

export const getColumns = (
  insertCols: any[] = []
): MxColumnType<any>[] => {
  return [
    {
      title: '数据属性/标识符',
      dataIndex: 'name',
      showForce: true,
      showComplete: true,
      keyList: ['dataPropertyName', 'identifier'],
      ellipsis: { showTitle: true },
      width: 180,
      fixed: 'left',
      render: (_: undefined, record) => (
        <EllipsisSpan value={!!record.hasProperty ? record.dataPropertyName : record.identifier} />
      ),
    },
    {
      title: '单位',
      dataIndex: 'physicalUnitGeneralName',
      ellipsis: { showTitle: true },
      width: 80,
      fixed: 'left',
      render: (value: string) => <EllipsisSpan value={value} />,
    },
    ...insertCols,
    {
      title: '采集点类型',
      dataIndex: 'hasProperty',
      ellipsis: { showTitle: true },
      width: 120,
      render: (value: boolean) => <EllipsisSpan value={value ? '建模采集点' : '非建模采集点'} />,
    },
    {
      title: '是否可写',
      dataIndex: 'writable',
      ellipsis: { showTitle: true },
      render: (v: string) => <EllipsisSpan value={v ? '是' : '否'} />,
    },
     {
          title: '数据过滤模式',
          dataIndex: 'valueFilterMode',
          ellipsis: { showTitle: true },
          width: 120,
          render: (_: undefined, record) => {
            return (
              <EllipsisSpan
                value={FilterModeDisplay[record.parameters?.valueFilterMode as keyof typeof FilterModeDisplay]}
              />
            );
          },
        },
        {
          title: '数值合理区间',
          dataIndex: 'dataRange',
          ellipsis: { showTitle: true },
          width: 120,
          render: (_: undefined, record) => {
            const value = getRange(record.parameters?.valueFloor, record.parameters?.valueCeiling);
            return <EllipsisSpan value={value} />;
          },
        },
        {
          title: '云端增长值合理区间',
          dataIndex: 'cloudValueRange',
          ellipsis: { showTitle: true },
          render: (_: undefined, record) => {
            const value = getRange(record.parameters?.cloudValueFloor, record.parameters?.cloudValueCeiling);
            return <EllipsisSpan value={value} />;
          },
        },
        {
          title: '云端异常数据过滤个数',
          dataIndex: 'cloudValueFilterCnt',
          ellipsis: { showTitle: true },
          render: (_: undefined, record) => {
            return <EllipsisSpan value={record.parameters.cloudValueFilterCnt} />;
          },
        },
    {
      title: '备注',
      dataIndex: 'remark',
      ellipsis: { showTitle: true },
      render: (value: string) => <EllipsisSpan value={value} />,
    },
  ];
};
